import TranslationIds from '../../../commons/translationIds';
import moment from 'moment';

export function getCurrentDate() {
    const now = moment();
    const formattedDate = now.format('DD-MM-YYYY'); 
    return formattedDate;
}

export const DefaultDate = {
    MONTH: '-',
    DAY: '-',
    YEAR: '-',
};

export function getCurrentYear () {
    return `${moment().year()}`;
}

export function getYears () {
    const year = getCurrentYear();
    const years = [];
    for (let i = 1905; i <= year; i++) {
        years.push({
            value: `${i}`,
            label: `${i}`,
        }); 
    }
    return years.reverse();
}

function dayToDD(day) {
    return String(day).padStart(2, '0');
}

export function getDaysInMonth(year, month) {
    const monthIndex = getMonthIndex(month);
    return moment([year, monthIndex]).daysInMonth(); 
}

export function getMonthIndex (monthString) {
    const month = moment(monthString, 'MM', true).month();
    return month;
}

export function getDays (year, month = null) {
    let numberOfDays = 31;
     
    if (month && month !== '-') {
        numberOfDays = getDaysInMonth(year, month); 
    }
   
    const days = [];
    for (let i = 1; i <= numberOfDays; i++) {
        // Now i=29 will stay "29", i=30 will stay "30", etc.
        days.push({
            label: `${i}`,
            value: dayToDD(i),
        });
    }
    return days;
}

export function toDateObj (formattedDate) {
    const d = {
        day: '00',
        month: '00',
        year: '00',
    };

    if (!formattedDate && typeof formattedDate.split !== 'function') {
        return d;
    }
    const parts = formattedDate.split('-');

    if (parts.length >= 1 && parts[0]) {
        d.day = parts[0];
    }

    if (parts.length >= 2 && parts[1]) {
        d.month = parts[1];
    }

    if (parts.length >= 3 && parts[2]) {
        d.year = parts[2];
    }

    return d;
}

export function getMonthsDataWithTranslation (translate,  skipLabel = false) {
    if (typeof translate !== 'function') {
        return [];
    }

    const allMonths = [
        { 
            value: '01',
            label:  translate(TranslationIds.COMPONENT_MONTH_JAN),
        },

        { 
            value: '02',
            label:  translate(TranslationIds.COMPONENT_MONTH_FEB),
        },

        { 
            value: '03',
            label:  translate(TranslationIds.COMPONENT_MONTH_MAR),
        },

        { 
            value: '04',
            label:  translate(TranslationIds.COMPONENT_MONTH_APR),
        },

        { 
            value: '05',
            label:  translate(TranslationIds.COMPONENT_MONTH_MAY),
        },

        { 
            value: '06',
            label:  translate(TranslationIds.COMPONENT_MONTH_JUN),
        },
        { 
            value: '07',
            label:  translate(TranslationIds.COMPONENT_MONTH_JUL),
        },
        { 
            value: '08',
            label:  translate(TranslationIds.COMPONENT_MONTH_AUG),
        },
        { 
            value: '09',
            label:  translate(TranslationIds.COMPONENT_MONTH_SEP),
        },
        { 
            value: '10',
            label:  translate(TranslationIds.COMPONENT_MONTH_OCT),
        },

        { 
            value: '11',
            label:  translate(TranslationIds.COMPONENT_MONTH_NOV),
        },
        { 
            value: '12',
            label:  translate(TranslationIds.COMPONENT_MONTH_DEC),
        },
    ];

    if (skipLabel) {
        return allMonths;
    }
    return [
        { 
            value: DefaultDate.MONTH,
            label:  translate(TranslationIds.COMPONENT_MONTH),
        },
        ...allMonths,
    ];
}


export function getDatesDataWithTranslation (p) {
    const {
        translate, 
        skipLabel = false,
        year = getCurrentYear(),
        month = '-', 
    } = p;
    if (typeof translate !== 'function') {
        return [];
    }

    if (skipLabel) {
        return [...getDays(year, month)];
    };

    return [
        {
            label: translate(TranslationIds.COMPONENT_DAY),
            value: DefaultDate.DAY,
        },
        ...getDays(year, month),
    ];
}

export function getYearsDataWithTranslation (translate, skipLabel = false) {
    if (typeof translate !== 'function') {
        return [];
    }

    if (skipLabel) {
        return getYears();
    }

    return [
        {
            label: translate(TranslationIds.COMPONENT_YEAR),
            value: DefaultDate.YEAR,
        },
        ...getYears(),
    ];
}
